/**
 * scroll-depth-analytics.js — #330 tracking addition 1 (theme-side dataLayer).
 *
 * Telemetry only; zero visible UX change. Emits one GA4 custom event to
 * window.dataLayer per scroll-depth threshold reached, once each per page load:
 *   scroll_depth  { percent_scrolled, surface, path }
 *
 * Purpose: quantify the "78% never reach a product" discovery leak on the
 * homepage and key collection pages (see issue #330, funnel → GA4 wiring).
 *
 * Purely additive and non-overlapping: this module introduces ONE new event
 * name that exists nowhere else in the theme. It never touches the existing
 * GA4-ecommerce emitters in snippets/ultimate-datalayer.liquid (add_to_cart,
 * remove_from_cart, view_cart, begin_checkout, ...) nor the cart→checkout seam
 * emitter (assets/cart-seam-analytics.js). This module never calls
 * preventDefault / stopPropagation and registers only passive listeners, so it
 * cannot alter scrolling or any other behaviour.
 *
 * GTM trigger/tag + GA4 custom dimension for scroll_depth live in the separate
 * openClawAgency workspace per the analytics boundary in AGENTS.md; wiring them
 * is a follow-on OS-083 step and is NOT part of this theme change.
 *
 * Loaded (deferred) only on the index + collection surfaces via
 * snippets/scroll-depth-datalayer.liquid.
 */
(function () {
  'use strict';

  // (1) Re-entry guard + dataLayer bootstrap.
  if (window.__mdScrollDepthAnalytics) return;
  window.__mdScrollDepthAnalytics = true;
  window.dataLayer = window.dataLayer || [];

  // (2) State — parse the #ScrollDepthState island, bail to safe defaults.
  var DEFAULTS = {
    surface: null,
    thresholds: [25, 50, 75, 90, 100],
  };

  function readIslandState() {
    var node = document.getElementById('ScrollDepthState');
    if (!node) return DEFAULTS;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      var thresholds = DEFAULTS.thresholds;
      if (Array.isArray(parsed.thresholds) && parsed.thresholds.length) {
        var cleaned = [];
        for (var i = 0; i < parsed.thresholds.length; i++) {
          var t = Number(parsed.thresholds[i]);
          if (isFinite(t) && t > 0 && t <= 100) cleaned.push(t);
        }
        if (cleaned.length) {
          cleaned.sort(function (a, b) {
            return a - b;
          });
          thresholds = cleaned;
        }
      }
      return {
        surface: parsed.surface != null ? String(parsed.surface) : null,
        thresholds: thresholds,
      };
    } catch (e) {
      return DEFAULTS;
    }
  }

  var island = readIslandState();
  var surface = island.surface;
  var thresholds = island.thresholds;

  // (3) Per-page fire guard — each threshold emits at most once per page load.
  var fired = {};

  function push(obj) {
    window.dataLayer.push(obj);
  }

  // (4) Depth measurement. percent = how far the BOTTOM of the viewport has
  // travelled through the document, so a page fully visible on load reads 100.
  function currentPercent() {
    var doc = document.documentElement;
    var body = document.body;
    if (!doc && !body) return 0;

    var scrollTop =
      window.pageYOffset ||
      (doc && doc.scrollTop) ||
      (body && body.scrollTop) ||
      0;

    var viewport = window.innerHeight || (doc && doc.clientHeight) || 0;

    var docHeight = Math.max(
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
      doc ? doc.clientHeight : 0,
      doc ? doc.scrollHeight : 0,
      doc ? doc.offsetHeight : 0
    );

    // Non-scrollable page (content shorter than viewport): fully seen = 100.
    if (docHeight <= viewport || docHeight <= 0) return 100;

    var pct = ((scrollTop + viewport) / docHeight) * 100;
    if (pct < 0) return 0;
    if (pct > 100) return 100;
    return pct;
  }

  function evaluate() {
    var pct = currentPercent();
    for (var i = 0; i < thresholds.length; i++) {
      var t = thresholds[i];
      if (fired[t]) continue;
      if (pct >= t) {
        fired[t] = true;
        push({
          event: 'scroll_depth',
          percent_scrolled: t,
          surface: surface,
          path: location.pathname,
        });
      }
    }
    if (allFired()) teardown();
  }

  function allFired() {
    for (var i = 0; i < thresholds.length; i++) {
      if (!fired[thresholds[i]]) return false;
    }
    return true;
  }

  // (5) rAF-throttled listener so scroll handling never blocks the main thread.
  var ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    var raf =
      window.requestAnimationFrame ||
      function (cb) {
        return setTimeout(cb, 16);
      };
    raf(function () {
      ticking = false;
      evaluate();
    });
  }

  function teardown() {
    window.removeEventListener('scroll', onScrollOrResize);
    window.removeEventListener('resize', onScrollOrResize);
    window.removeEventListener('orientationchange', onScrollOrResize);
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });
  window.addEventListener('orientationchange', onScrollOrResize, { passive: true });

  // (6) Initial evaluation — catches above-the-fold-only pages and load-time
  // scroll restoration.
  evaluate();
})();
